import React, { useState, useEffect } from "react";
import FilterAufaDocketsHead from "./FilterAufaDocketsHead";
import FilterAufaDocketsData from "./FilterAufaDocketsData";
import { fetchGetAufa, fetchGetFilter } from "../../../faetures/fetch";

const AufaFilterDockets = ({ openNumDocket }) => {

    const formatDateForInput = (date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    };

    const today = new Date();

    const [data, setData] = useState([]);
    const [workers, setWorkers] = useState([]); // Add state for storing unique workers
    const [filteredData, setFilteredData] = useState([]);
    const [filterCriteria, setFilterCriteria] = useState({
        status: "*",
        aufa_id: "*", // aufa number
        docket_id: "*",
        date_f: formatDateForInput(today),  // Start date
        date_e: formatDateForInput(today),  // End date
        office: localStorage.getItem('office_number'), // Office filter
        work: "*",    // Worker filter
        sortByDocket: false
    });


    useEffect(() => {
        fetchGetFilter('/aufa')
            .then(response => {
                setData(response.data);
                setFilteredData(response.data); // Initially, show all data
                console.log(response.data);
                // Extract unique workers
                const uniqueWorkers = [...new Set(response.data.map(item => item.worker))];
                setWorkers(uniqueWorkers);


            })
            .catch(error => {
                console.error("Error fetching dockets data", error);
            });
    }, []);

    useEffect(() => {
        // Extract unique workers based on the selected office
        let uniqueWorkers = data
            .filter(item => filterCriteria.office === "*" || item.office === filterCriteria.office)
            .map(item => item.worker);
    
        // Get unique workers only (eliminate duplicates)
        uniqueWorkers = [...new Set(uniqueWorkers)];
    
        setWorkers(uniqueWorkers);
    }, [filterCriteria.office, data]);
    

    useEffect(() => {
        // Filter data based on the criteria whenever it changes
        let filtered = data.filter(item => {
            const statusMatch = filterCriteria.status === "*" || item.status === parseInt(filterCriteria.status);
            const aufaMatch = filterCriteria.aufa_id === "*" || item.aufa_id === parseInt(filterCriteria.aufa_id);
            const docketMatch = filterCriteria.docket_id === "*" || item.docket_id === parseInt(filterCriteria.docket_id);
            const dateMatch = (!filterCriteria.date_f || new Date(item.date.split('/').reverse().join('-')) >= new Date(filterCriteria.date_f)) &&
                (!filterCriteria.date_e || new Date(item.date.split('/').reverse().join('-')) <= new Date(filterCriteria.date_e));
            const officeMatch = filterCriteria.office === "*" || item.office === filterCriteria.office;
            const workerMatch = filterCriteria.work === "*" || item.worker === filterCriteria.work;

            return statusMatch && aufaMatch && docketMatch && dateMatch && officeMatch && workerMatch;
        });

        // Sort by docket number if the checkbox is checked
        switch (filterCriteria.sortOption) {
            case "docketAsc":
                filtered = filtered.sort((a, b) => a.docket_id - b.docket_id);
                break;
            case "docketDesc":
                filtered = filtered.sort((a, b) => b.docket_id - a.docket_id);
                break;
            case "dateAsc":
                filtered = filtered.sort((a, b) => new Date(a.date.split('/').reverse().join('-')) - new Date(b.date.split('/').reverse().join('-')));
                break;
            case "dateDesc":
                filtered = filtered.sort((a, b) => new Date(b.date.split('/').reverse().join('-')) - new Date(a.date.split('/').reverse().join('-')));
                break;
            default:
                filtered = filtered.sort((a, b) => a.docket_id - b.docket_id);
                break;
        }
    

        setFilteredData(filtered);
    }, [filterCriteria, data]);

    const handleFilterChange = (newCriteria) => {
        const updatedCriteria = {
            ...newCriteria,
            aufa_id: newCriteria.aufa_id === "" ? "*" : newCriteria.aufa_id,
            docket_id: newCriteria.docket_id === "" ? "*" : newCriteria.docket_id,
        };
        setFilterCriteria(updatedCriteria);

    };

    return (
        <div style={{
            width: '85%',
            height: '80vh',
            margin: '0 auto',
            padding: '20px',
        }}>
            <FilterAufaDocketsHead data={filterCriteria} setData={handleFilterChange} workers={workers} />
            <FilterAufaDocketsData data={filteredData} openNumDocket={openNumDocket} />
        </div>
    );
};

export default AufaFilterDockets;